import { useCallback, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'src/utils/store'
import { useDispatch } from 'react-redux'
import { actions } from '../../../RestockingState'
import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'
import { useBlockPopAction } from 'src/hooks/useBlockPopAction'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import Page from 'src/features/restocking/components/RestockingWebAppForm/components/Page/Page'
import UserIdentifier from 'src/features/restocking/components/RestockingWebAppForm/components/UserIdentifier/UserIdentifier'
import UserGuidance from 'src/features/restocking/components/RestockingWebAppForm/components/UserGuidance/UserGuidance'
import ScanCode from 'src/features/restocking/components/RestockingWebAppForm/components/ScanCode/ScanCode'
import * as S from './RestockAddressPage.styles'

interface FormData {
  addressCode: string;
}

const RestockAddressPage: React.FC = () => {
  const { user, currentProductToRestock, isRestockAddressValid } = useSelector((state) => state.restocking)
  const { register, getValues, reset } = useForm<FormData>()
  const { fc, validateFc } = useFulfillmentCenter()
  const dispatch = useDispatch()
  const history = useHistory()

  useBlockPopAction()

  useEffect(() => {
    validateFc()
  }, [validateFc])

  const onSuccess = useCallback(() => {
    history.push('/restocking/webapp/restock-product')
  }, [history])

  const productToRestock = user.itemsToRestock?.find((item) => !item.done)

  const restockAddress = productToRestock?.location.address

  const onSubmit = () => {
    if (!productToRestock) return

    if (!currentProductToRestock) {
      dispatch(actions.setProperty({
        property: 'currentProductToRestock',
        value: productToRestock,
      }))
    }

    const addressCode = getValues('addressCode').trim()

    dispatch(actions.restockingValidateRestockAddress({
      badge: user.badge,
      idPageItem: productToRestock.idPageItem,
      address: addressCode,
      isGondola: productToRestock.location.isGondola,
      idFulfillmentCenter: fc.id,
      onFail: () => reset({ addressCode: '' }),
    }))
  }

  useEffect(() => {
    if (isRestockAddressValid && productToRestock) {
      const { idPageItem, idModel } = productToRestock

      dispatch(actions.startRestockingAddressRestock({
        badge: user.badge,
        idItem: idPageItem,
        idModel,
        history,
        onSuccess,
      }))
    }
  }, [dispatch, onSuccess, history, isRestockAddressValid, productToRestock, user.badge])

  return (
    <Page headerTitle='Reposição' goBackRoute='/restocking/webapp/badge' isRestocking hasBackButton={false}>
      <S.Info>
        <UserIdentifier idPage={productToRestock?.idPage}/>
        <UserGuidance text='Dirija-se para:'>
          {
            restockAddress && (
              <Typography style={{ fontWeight: 'bold', fontSize: '30px' }}>{restockAddress}</Typography>
            )
          }
        </UserGuidance>
      </S.Info>
      <S.Form>
        <ScanCode
          text='Ao chegar bipe o código do endereço.'
          onSubmit={onSubmit}
          register={register}
          dataTestId='input-address-code-test-id'
          inputName='addressCode'
          errorMessage='Endereço incorreto!'
        />
      </S.Form>
    </Page>
  )
}

export default RestockAddressPage
